export default "__VITE_ASSET__DKvdbBhk__"